type CommonState = {
  isGlobalLoading: boolean;
  isSessionExpiredDialogOpen: boolean;
  label: string;
  strapiCoreSettings: Record<string, any>;
  isShownCookieDialog: boolean;
  appConfig: Record<string, any>;
};

type MenuItem = {
  strapiKey?: string;
  [key: string]: unknown;
};

export default {
  namespaced: true,
  state: {
    isGlobalLoading: false,
    isSessionExpiredDialogOpen: false,
    label: '',
    strapiCoreSettings: {},
    isShownCookieDialog: false,
    appConfig: {},
  } as CommonState,
  mutations: {
    changeCookieDialogOpenState(state: CommonState, isShown: boolean) {
      state.isShownCookieDialog = isShown;
    },
    setGlobalLoading(state: CommonState, isGlobalLoading: boolean) {
      state.isGlobalLoading = isGlobalLoading;
    },
    setLabel(state: CommonState, label: string) {
      state.label = label;
    },
    changeSessionExpiredDialogOpenState(state: CommonState, dialogState: boolean) {
      state.isSessionExpiredDialogOpen = dialogState;
    },
    setStrapiCoreSettings(state: CommonState, data: Record<string, any>) {
      state.strapiCoreSettings = data;
    },
    setAppConfig(state: CommonState, data: Record<string, any>) {
      state.appConfig = data;
    },
  },
  actions: {
  },
  getters: {
    getIsShownCookieDialog: (state: CommonState) => state.isShownCookieDialog,
    isGlobalLoading: (state: CommonState) => state.isGlobalLoading,
    getLabel: (state: CommonState) => state.label,
    getIsSessionExpiredDialogOpen: (state: CommonState) => state.isSessionExpiredDialogOpen,
    getStrapiCoreSettings: (state: CommonState) => state.strapiCoreSettings,
    getStrapiCoreMenu: (state: CommonState) => (menuItems: MenuItem[]) => menuItems.map((menuItem) => {
      if (state.strapiCoreSettings.navLinks) {
        let strapiMenuItem = '';
        Object.keys(state.strapiCoreSettings.navLinks)
          .forEach((key) => {
            if (key === menuItem.strapiKey) {
              strapiMenuItem = state.strapiCoreSettings.navLinks[key];
            }
          });
        return {
          ...menuItem,
          strapiText: strapiMenuItem,
        };
      }
      return menuItem;
    }),
    getAppConfig: (state: CommonState) => state.appConfig,
  },
};
